import {IInputProps, Input as NativeBaseInput} from 'native-base';
import React from 'react';
import {colorSwatches} from '../styles';
import shouldAutoFocus from '../utils/shouldAutoFocus';

const Input = (props: IInputProps) => {
  const {style, autoFocus, ...rest} = props;

  return (
    <NativeBaseInput
      style={[{fontSize: 18}, style]}
      _disabled={{
        backgroundColor: colorSwatches.gray.color,
      }}
      _readOnly={{
        backgroundColor: colorSwatches.gray.color,
      }}
      autoFocus={shouldAutoFocus(autoFocus)}
      {...rest}
      _stack={{style: {}}}
    />
  );
};

export default Input;
